module.exports = __webpack_public_path__ + "static/watergarden-011b35cbe2c91be59e377ad7ee0ec506.jpg";